import { Box, Container, Modal, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { String } from "../../constants/Strings";
import { ReactComponent as ConnectAccountInfo } from "../../assets/img/connectaccountdots.svg";
import ACRButton from "../../commanComponents/ACRButton";
import { getColor } from "../../style/color/color";
import { useNavigate } from "react-router-dom";
import WebViewComponent from "./WebViewComponent";
import { DataContext } from "../../Hooks/context/ChildData";
import { useAccountAggregator } from "../../api/apiEndpoints/AccountAggragator";
import { AuthContext } from "../../Hooks/context/AuthContext";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import { AccountAagregatorContext } from "../../Hooks/context/AccountAaggregator";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const InfoFetch = () => {
  const [iframesrc, setIframesrc] = useState(null);
  const [open, setOpen] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [pollingInterval, setPollingInterval] = useState(null);
  const [pollingCounter, setPollingCounter] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const navigation = useNavigate();
  const { EnterManually } = useContext(DataContext);
  const { startJouenry, startPolling, getResult } = useAccountAggregator();
  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { collectAccountAggregatorData } = useContext(AccountAagregatorContext);
  const { userId } = authTokens;

  //Start polling when user start account aggregator journey
  const startPollingResult = async (data) => {
    if (data) {
      const response = await startPolling({ requestId: data });
      if (
        response.httpCode === 200 &&
        response.response.state.state === "SUCCESS"
      ) {
        clearInterval(pollingInterval);
        const result = await getResult({ requestId: data, userId: userId });
        collectAccountAggregatorData(result);
        navigation("/financialsnapshot", { state: { replace: true } });
      }
      setPollingCounter((prevCounter) => prevCounter + 1);
      if (pollingCounter >= 25) {
        setIframesrc(null);
        setOpen(false);
        setPollingCounter(0);
        setSnackbarMessage({
          message: String.AccountAggregator.faildOFetchDatainPolling,
          severity: String.ErrorSeverity,
        });
        setShowSnackbar(true);
        clearInterval(pollingInterval);
      }
    }
  };
  //Dynamically decrease thr polling counter
  useEffect(() => {
    if (iframesrc !== null && requestId) {
      const interval = setInterval(() => {
        startPollingResult(requestId);
      }, 15000);
      setPollingInterval(interval);

      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframesrc, requestId, pollingCounter]);

  //Calls when user click connect all account button
  const handleClick = async () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioFetchInfoConnectAllAccounts, verifyData.customerId);
    EnterManually(true);

    const response = await startJouenry({ userId: userId });
    if (response.httpCode === 200) {
      setIframesrc(response.response.redirectUrl);
      setRequestId(response.response.requestId);

      setOpen(true);
    }
    if (response === typeof "String") {
      setSnackbarMessage({ message: response, severity: String.ErrorSeverity });
      setShowSnackbar(true);
    }
  };
  //Manual button redirect to financial snapshot screen
  const manualButton = () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioFetchInfoManually, verifyData.customerId);
    EnterManually(false);
    navigation("/financialsnapshot", { state: { replace: false } });
  };
  return (
    <>
      <Box
        sx={{
          height: "100vh",
        }}
      >
        <Container sx={{ flexGrow: 1 }}>
          <PageTitle PageTitle={String.AccountAggregator.Title} />
          <LinearProgressBar
            dragMessage={String.AccountAggregator.dragMessage}
            progress={55}
            progressNumber={55}
            stepNumber={3}
          />
        </Container>
        {/* <ConnectAccounts /> */}{" "}
        <Box>
          <ConnectAccountInfo
            style={{
              width: "85%",
              maxWidth: "400px",
              objectFit: "contain",
              display: "block",
              margin: "0 auto",
              marginTop: "40px",
            }}
          />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              mt: "60px",
            }}
          >
            <ACRButton
              label={String.AccountAggregator.buttonName}
              style={{
                width: "100%",
                maxWidth: "350px",
                backgroundColor: getColor.ColorButtonPrimarysurface,
                color: getColor.PrimaryWhite,
                borderRadius: "40px",
                p: "10px",
                height: "60px",
                mb: "40px",
                lineHeight: "22.2px",
                fontWeight: 600,
                fontSize: "16px",
                textAlign: "center",
                textTransform: "initial",
              }}
              onClickButton={handleClick}
            />
            <Typography
              sx={{
                color: getColor.ColorButtonPrimarysurface,
                fontSize: "16px",
                marginTop: "40px",
                fontFamily: fonts.manrope,
                fontWeight: 700,
              }}
              component={"div"}
              onClick={manualButton}
            >
              {String.AccountAggregator.EnterManuallyButton}
            </Typography>
          </Box>
        </Box>
        {/* Opens iframe with AA journey */}
        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
            if (pollingCounter >= 3) {
              setShowSnackbar(true);
            }
          }}
          aria-labelledby="webview-modal-title"
          aria-describedby="webview-modal-description"
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              bgcolor: "background.paper",
              boxShadow: 24,

              borderRadius: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {iframesrc !== null && (
              <WebViewComponent url={iframesrc} setOpen={setOpen} />
            )}
          </Box>
        </Modal>
      </Box>

      <CustomSnackbar
        open={showSnackbar}
        handleClose={() => setShowSnackbar(false)}
        message={snackbarMessage.message}
        severity={snackbarMessage.severity}
      />
    </>
  );
};

export default InfoFetch;
